module.exports = __webpack_public_path__ + "img/diamond.3f6dbc04.png";